// extracted by mini-css-extract-plugin
export default {"adAccount":"nsmUh41Ale_417A2mgCL","select":"ry7ctzq8ozE0zx3hcEbk","arrow":"cwdYykARt1HCKreb17Ln","connectPage":"loba5RTuhnCI2PSLkjI8","alert":"n9o3ujcykZscDJnO6_AP"};